import { render, staticRenderFns } from "./params-section.component.vue?vue&type=template&id=399650e6&scoped=true"
import script from "./params-section.component.vue?vue&type=script&lang=js"
export * from "./params-section.component.vue?vue&type=script&lang=js"
import style0 from "./params-section.component.vue?vue&type=style&index=0&id=399650e6&prod&lang=scss"
import style1 from "./params-section.component.vue?vue&type=style&index=1&id=399650e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399650e6",
  null
  
)

export default component.exports